import axios from '../config/http'
import qs from 'qs'
import { baseUrl } from '../config/env'

/**
 **************************首页****************************
 */
/**  获取公共参数 **/
export const getPublicData = (data) => {
  let url = baseUrl + '/home/getpublic'
  let response = axios.get(url)
  return response
}
/**  获取header数据 **/
export const getLogoData = (data) => {
  let url = baseUrl + '/home/getlogo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}
/**  获取header数据 **/
export const getHeaderData = (data) => {
  let url = baseUrl + '/home/getheader'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  获取头部导航数据 **/
export const getHeaderNavData = () => {
  let url = baseUrl + '/home/getsort'
  let response = axios.get(url)
  return response
}

/**  获取首页信息 **/
export const getHomeData = (data) => {
  let url = baseUrl + '/home/index'
  let response = axios.get(url)
  return response
}

/**
 **************************居家养老****************************
 */
/**  基本信息 **/
export const getHomeCareBasicData = (data) => {
  let url = baseUrl + '/care/index'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  列表 **/
export const getHomeCareListData = (data) => {
  let url = baseUrl + '/care/getlist'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  详情 **/
export const getHomeCareDetailData = (data) => {
  let url = baseUrl + '/care/detail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************机构养老****************************
 */
/**  基本信息 **/
export const getMechanismBasicData = (data) => {
  let url = baseUrl + '/agency/index'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  列表 **/
export const getMechanismListData = (data) => {
  let url = baseUrl + '/agency/getlist'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  详情 **/
export const getMechanismDetailData = (data) => {
  let url = baseUrl + '/agency/detail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************预约****************************
 */
/** 获取亲属关系列表 **/
export const getRelationData = () => {
  let url = baseUrl + '/reserve/getrelation'
  let response = axios.get(url)
  return response
}
export const addService = (data) => {
  let url = baseUrl + '/reserve/addservice'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}
export const registerService = (data) => {
  let url = baseUrl + '/reserve/registservice'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************关于我们****************************
 */
/**  基本信息 **/
export const getAboutBasicData = (data) => {
  let url = baseUrl + '/about/index'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  列表 **/
export const getAboutData = (data) => {
  let url = baseUrl + '/about/getinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************公益之窗****************************
 */
/**  基本信息 **/
export const getPublicWelfareBasicData = (data) => {
  let url = baseUrl + '/welfare/index'
  let response = axios.get(url)
  return response
}

/**  列表 **/
export const getPublicWelfareListData = (data) => {
  let url = baseUrl + '/welfare/getlist'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************长者课堂****************************
 */
/**  基本信息 **/
export const getSeniorClassBasicData = (data) => {
  let url = baseUrl + '/lesson/index'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  列表 **/
export const getSeniorClassListData = (data) => {
  let url = baseUrl + '/lesson/getlist'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  详情 **/
export const getSeniorClassDetailData = (data) => {
  let url = baseUrl + '/lesson/detail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************加入我们****************************
 */
/**  基本信息 **/
export const getJoinBasicData = (data) => {
  let url = baseUrl + '/join/index'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  详情 **/
export const getJoinDetailData = (data) => {
  let url = baseUrl + '/join/getinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  招聘列表 **/
export const getJobListData = (data) => {
  let url = baseUrl + '/join/getjob'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  加入我们  提交表单 **/
export const postJoinMessage = (data) => {
  let url = baseUrl + '/join/savemessage'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************动态资讯****************************
 */
/**  基本信息 **/
export const getNewsBasicData = () => {
  let url = baseUrl + '/news/index'
  let response = axios.get(url)
  return response
}

/**  列表 **/
export const getNewsListData = (data) => {
  let url = baseUrl + '/news/getlist'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**  详情 **/
export const getNewsDetailData = (data) => {
  let url = baseUrl + '/news/detail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/**
 **************************用户中心****************************
 */
/** 用户基本信息 **/
export const getMemberData = (data) => {
  let url = baseUrl + '/member/getinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 修改用户基本信息 **/
export const updateMemberData = (data) => {
  let url = baseUrl + '/member/editinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取文化程度列表 **/
export const getEducationData = () => {
  let url = baseUrl + '/member/geteducation'
  let response = axios.get(url)
  return response
}

/** 获取用户安全信息 **/
export const getSecurityData = (data) => {
  let url = baseUrl + '/member/getbindinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取邮箱验证码 **/
export const getEmailCodeData = (data) => {
  let url = baseUrl + '/member/sendemail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 修改绑定邮箱 **/
export const updateBindEmail = (data) => {
  let url = baseUrl + '/member/bindemail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 修改邮箱第一步 **/
export const checkEmail = (data) => {
  let url = baseUrl + '/member/editemail'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取修改邮箱第一步验证码 **/
export const getCheckEmailCode = (data) => {
  let url = baseUrl + '/member/sendmail_e'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取手机验证码 **/
export const getMobileCodeData = (data) => {
  let url = baseUrl + '/member/getcode_b'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 修改绑定手机号 **/
export const updateBindMobile = (data) => {
  let url = baseUrl + '/member/bindmobile'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 修改手机号第一步 **/
export const checkMobile = (data) => {
  let url = baseUrl + '/member/editmobile'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取修改手机号第一步验证码 **/
export const getCheckMobileCode = (data) => {
  let url = baseUrl + '/member/getcode_m'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取用户预约信息 **/
export const getReserveData = (data) => {
  let url = baseUrl + '/member/serveinfo'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取用户家庭成员列表 **/
export const getFamilyData = (data) => {
  let url = baseUrl + '/member/getfamily'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 添加用户家庭成员 **/
export const addFamilyData = (data) => {
  let url = baseUrl + '/member/addfamily'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 取消用户家庭成员 **/
export const delFamilyData = (data) => {
  let url = baseUrl + '/member/delfamily'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 绑定用户基本信息 **/
export const getBindMemberData = (data) => {
  let url = baseUrl + '/member/getinfo_b'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取绑定用户预约信息 **/
export const getBindReserveData = (data) => {
  let url = baseUrl + '/member/serveinfo_b'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 检测手机号是否绑定 **/
export const checkBindMobileData = (data) => {
  let url = baseUrl + '/member/checkphone'
  let postdata = data
  let response = axios.post(url, qs.stringify(postdata))
  return response
}

/** 获取用户协议 **/
export const getAgreementData = () => {
  let url = baseUrl + '/member/getprotocol'
  let response = axios.get(url)
  return response
}
